import { useNavigate } from "react-router";
import ErrorModal from "./errormodal/ErrorModal";
import errroMessage from "./errormodal/errormessage.json";
import { useGetRole } from "../../experience/generic/hooks/useGetRole";
import { RoleToLinkMapper } from "../../experience/utils/UrlUtils";

const ErrorPage = ({ code }) => {
  const navigate = useNavigate();
  const role = useGetRole();

  const getErrorCode = () => {
    const parameters = new URLSearchParams(window.location.search);
    return parameters.get("code");
  };

  const getFormatMessage = () => {
    const codeFromURL = getErrorCode();
    return errroMessage[codeFromURL];
  };

  const message = code ? errroMessage[code] : getFormatMessage();

  const handleClick = () => {
    const errorCode = getErrorCode();
    if (errorCode === "1002" || errorCode === "1004" || errorCode === "1005") {
      navigate("/login");
    } else {
      if (role) {
        if (role === "Billing Admin") {
          navigate("/billingAdmin/billing");
        } else {
          navigate(RoleToLinkMapper(role) + "homepage");
        }
      } else {
        navigate("/");
      }
    }
  };

  return <ErrorModal message={message} primaryActionLabel="Go Back" primaryActionColor="#0593A1" handleClick={handleClick} />;
};

export default ErrorPage;
